<div class="feature-flags-list">
  <div class="list-filters">
    <div class="filter-group">
      <!-- Material Search Input -->
      <mat-form-field appearance="outline" class="search-container">
        <mat-label>Search feature flags</mat-label>
        <input matInput [formControl]="searchFilter" placeholder="Search feature flags..." />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>

      <!-- Material Select for Status Filter -->
      <mat-form-field appearance="outline" class="status-filter">
        <mat-label>Status</mat-label>
        <mat-select [formControl]="statusFilter" (selectionChange)="onStatusFilterChange()">
          <mat-option value="all">All</mat-option>
          <mat-option value="active">Active</mat-option>
          <mat-option value="archived">Archived</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="action-buttons">
      <!-- Material Button for Create -->
      <button mat-flat-button color="primary" id="e2e-create-flag" (click)="onCreateFlag()">
        <span>Create Flag</span>
      </button>
    </div>
  </div>

  <div class="flag-list-container">
    <!-- Loading Spinner using Material -->
    <div *ngIf="loading()" class="loading-indicator">
      <mat-spinner diameter="30"></mat-spinner>
      <p>Loading feature flags...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading() && !hasFlags()" class="empty-state">
      <mat-icon class="empty-icon">assignment</mat-icon>
      <h3>No feature flags found</h3>
      <p>
        {{
          statusFilter.value === 'all'
            ? 'No feature flags exist yet.'
            : 'No ' + statusFilter.value + ' feature flags found.'
        }}
      </p>
      <button mat-raised-button (click)="onCreateFlag()">
        <mat-icon>add</mat-icon>
        <span>Create Feature Flag</span>
      </button>
    </div>

    <!-- Material Table -->

    <mat-table
      *ngIf="!loading() && hasFlags()"
      [dataSource]="featureFlags()"
      matSort
      (matSortChange)="setSortColumn($event.active)"
      class="mat-elevation-z1"
    >
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let flag">{{ flag.name }}</mat-cell>
      </ng-container>

      <!-- Description Column -->
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
        <mat-cell *matCellDef="let flag">{{ flag.description }}</mat-cell>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let flag">
          <mat-chip-list>
            <mat-chip
              [class.active-status]="flag.status === 'active'"
              [class.archived-status]="flag.status === 'archived'"
            >
              {{ flag.status }}
            </mat-chip>
          </mat-chip-list>
        </mat-cell>
      </ng-container>

      <!-- Updated At Column -->
      <ng-container matColumnDef="updatedAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let flag">{{ flag.updatedAt | date: 'MM/dd/yyyy' }} by {{ flag.updatedBy }}</mat-cell>
      </ng-container>

      <!-- Header Row -->
      <mat-header-row *matHeaderRowDef="['name', 'description', 'status', 'updatedAt']"></mat-header-row>

      <!-- Data Rows -->
      <mat-row
        *matRowDef="let row; columns: ['name', 'description', 'status', 'updatedAt']"
        (click)="onSelectFlag(row.id)"
        class="flag-row"
      ></mat-row>
    </mat-table>
  </div>
</div>
